import React from 'react';

const Ec = () => {
  return (
    <div className="bg-gray-50 py-10 px-4 min-h-screen">
      <div className="max-w-5xl mx-auto  p-6 sm:p-10">
        {/* Title */}
        <h1 className="text-3xl sm:text-4xl font-bold text-[#b7b7a1] mb-6">
          Encumbrance Certificate Services
        </h1>

        {/* Introduction Paragraphs */}
        <div className="space-y-4 text-gray-700 text-base leading-relaxed">
          <p>
            Our experienced staff and consultants specialize in assisting customers in obtaining
            Encumbrance Certificates and certified copies of registered documents for any year in and
            around Bangalore. With a deep understanding of the local property laws and registration
            processes, our team efficiently navigates the administrative requirements to ensure that
            clients receive the necessary documentation without unnecessary delays.
          </p>
          <p>
            We provide personalized support throughout the entire process, from gathering and verifying
            essential details to liaising with government offices and responding to any inquiries that
            may arise. By leveraging our expertise, clients can easily access crucial property records,
            ensuring they have the necessary information to safeguard their interests in real estate
            transactions.
          </p>
          <p>
            Our commitment is to deliver accurate and timely services, empowering customers with the
            documentation they need with confidence and ease.
          </p>
        </div>

        {/* Divider */}
        <div className="my-8 border-t-2 border-[#b7b7a1]" />

        {/* EC Objectives */}
        <h2 className="text-2xl font-semibold text-[#b7b7a1] mb-4">
          Objective of Obtaining an Encumbrance Certificate
        </h2>
        <p className="text-gray-700 mb-4">
          We will obtain Encumbrance and Certificate of any year and Certified copies of Registered
          documents in any Sub-Registrar office.
        </p>

        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li>
            <strong>Establish Clear Title:</strong> Confirm that the property being considered for purchase
            or investment does not have any outstanding mortgages, loans, liens, or other encumbrances.
          </li>
          <li>
            <strong>Facilitate Transactions:</strong> Facilitate smooth property transactions by ensuring
            that buyers and lenders can verify the legal status of the property, reducing the risk of
            disputes or legal complications.
          </li>
          <li>
            <strong>Support Financing Applications:</strong> Assist in securing financing or loans by
            providing lenders with necessary documentation that demonstrates the property’s free status
            from claims.
          </li>
          <li>
            <strong>Protect Against Fraud:</strong> Protect potential buyers from fraud and title disputes
            by providing official records of the property’s ownership history.
          </li>
          <li>
            <strong>Ensure Compliance:</strong> Ensure compliance with legal and regulatory requirements,
            helping individuals and businesses navigate the complexities of real estate transactions
            effectively.
          </li>
          <li>
            <strong>Aid in Due Diligence:</strong> Serve as a critical component in due diligence for
            property buyers and investors, helping them make informed decisions regarding real estate
            investments.
          </li>
        </ul>

        {/* Divider */}
        <div className="my-8 border-t-2 border-[#b7b7a1]" />

        {/* Registered Documents Objective */}
        <h2 className="text-2xl font-semibold text-[#b7b7a1] mb-4">
          Objective of Obtaining Certified Copies of Registered Documents
        </h2>

        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li>
            <strong>Establish Legal Validity:</strong> Provide a legally recognized and officially
            verified version of property documents, confirming ownership and rights.
          </li>
          <li>
            <strong>Facilitate Transactions:</strong> Support real estate transactions by providing clear
            evidence of property title, which is essential for buyers, sellers, and lenders.
          </li>
          <li>
            <strong>Ensure Transparency:</strong> Ensure transparency in property dealings by making the
            documentation accessible for verification by involved parties, such as buyers, banks, and
            legal authorities.
          </li>
          <li>
            <strong>Aid in Dispute Resolution:</strong> Serve as authoritative proof in case of disputes
            regarding ownership, boundaries, or property rights, aiding in resolution processes.
          </li>
          <li>
            <strong>Preserve Historical Records:</strong> Maintain an accurate historical record of
            property transactions, which can be essential for future reference or legal matters.
          </li>
          <li>
            <strong>Support Financing Applications:</strong> Assist in the mortgage or loan application
            process by providing lenders with necessary documentation to evaluate the property’s status
            and value.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Ec;
